<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Tích hợp" :link="[{ text: 'Tích hợp', href: '../integration' }]" />
      </div>
    </div>
    <v-tabs v-model="tab" active-class="tab-active" class="mx-4" background-color="transparent">
      <v-tab class="tab-default" :key="1">Điểm danh</v-tab>
    </v-tabs>
    <v-card class="px-md-6 mx-md-4 elevation-0" outlined>
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1">
          <AttendanceStatusTab />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import AttendanceStatusTab from '@/modules/integrations/AttendanceStatusTab.vue'

export default {
  components: {
    Breadcrumbs,
    AttendanceStatusTab
  },
  data() {
    return {
      tab: 0
    }
  }
}
</script>
